const mul32 = (a, b) => Math.imul(a, b);
export default mul32;
